import type { EventId } from '@ps/isp-web-services-types';
import React from 'react';

import type { EventLevelEventTemplateId } from '@swf/sports/types/templates';

import EventMoreMarkets from './templates/EventMoreMarkets';

interface Props {
  eventId: EventId;
}

const EVENT_TEMPLATE_MAP: Record<EventLevelEventTemplateId, React.ElementType<Props>> = {
  EVENT_MORE_MARKETS: EventMoreMarkets
};

export const EventTemplate: React.FC<
  Props & {
    templateId: EventLevelEventTemplateId;
  }
> = ({ eventId, templateId }) => {
  const Component: React.ElementType<Props> = EVENT_TEMPLATE_MAP[templateId];
  return <Component eventId={eventId} />;
};
